import { Routes } from '@angular/router';
import { getSubdomainPart } from '@core/services/get-subdomain';
import { clinicRoutes } from './clinic/clinic.routes';
import { patientRoutes } from './patient/patient.routes';
import { canActivateClinic } from '@core/guards/clinic-subdomain.guard';

const routes: Routes = [
  {
    path: 'error',
    pathMatch: 'full',
    loadComponent: () => import('./error/error.component').then((m) => m.ErrorComponent),
  },
];

if (getSubdomainPart() === 'patient' || getSubdomainPart() === 'tele-patient') {
  routes.push({
    path: '',
    loadChildren: () => import('./patient/patient.routes').then(() => patientRoutes),
  });
}
if (getSubdomainPart() && getSubdomainPart() !== 'patient' && getSubdomainPart() !== 'tele-patient') {
  routes.push({
    path: '',
    canActivate: [canActivateClinic],
    loadChildren: () => import('./clinic/clinic.routes').then(() => clinicRoutes),
  });
}

export default routes;
